export interface BMUser {
  pto: number;
  redmine_login: string;
  github_user: string;
  display_name: string;
  slack_id: string;
  fulltime: boolean;
  start_date: Date | null;
  availability: number;
  redmine_id: number;
}

export function BMUserFromJSON(json: any): BMUser {
  return {
    pto: json["pto"],
    redmine_login: json["redmine_login"],
    github_user: json["github_user"],
    display_name: json["display_name"],
    slack_id: json["slack_id"],
    fulltime: json["fulltime"],
    start_date: json["start_date"] ? new Date(json["start_date"]) : null,
    availability: json["availability"],
    redmine_id: json["redmine_id"],
  };
}

export interface AuditBMUser {
  audit_id: number;
  operation_type: string;
  old_values: Record<string, any> | null;
  new_values: Record<string, any> | null;
  audit_date: Date;
  actor_username: string;
  target_user_id: number | null;
  target_user_login: string | null;
}

export function AuditBMUserFromJSON(json: any): AuditBMUser {
  return {
    audit_id: json["audit_id"],
    operation_type: json["operation_type"],
    old_values: json["old_values"] ?? null,
    new_values: json["new_values"] ?? null,
    audit_date: new Date(json["audit_date"]),
    actor_username: json["actor_username"],
    target_user_id: json["target_user_id"] ?? null,
    target_user_login: json["target_user_login"] ?? null,
  };
}
